import { render, staticRenderFns } from "./FailedTransaction.vue?vue&type=template&id=73fdfe22&scoped=true"
import script from "./FailedTransaction.vue?vue&type=script&lang=js"
export * from "./FailedTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdfe22",
  null
  
)

export default component.exports